import { Box, Tooltip } from '@mui/material';
import React from 'react';
import MotivoSquareLogo from './Header/MotivoSquareLogo';

type MotivoSupervisorBadgeProps = {
  size?: number;
};

export function MotivoSupervisorBadge({ size = 20 }: MotivoSupervisorBadgeProps) {
  return (
    <Tooltip title="Motivo supervisor">
      <Box sx={{ display: 'flex' }}>
        <MotivoSquareLogo width={size} height={size} />
      </Box>
    </Tooltip>
  );
}
